import api from '../api';
import axios from 'axios';
export default {
    CREATE_UserAssignBoard: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.userassignboard.CREATE_UserAssignBoard(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_ALL_UserAssignBoard: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.userassignboard.GET_ALL_UserAssignBoard())
                .then((res) => resolve(res?.data?.data))
                .catch((err) => reject(err));
        });
    },
    DELETE_UserAssignBoard: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.userassignboard.DELETE_UserAssignBoard(id))
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },
    UPDATE_UserAssignBoard: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.userassignboard.UPDATE_UserAssignBoard(id), data)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },

    GET_UserAssignBoard_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.userassignboard.GET_UserAssignBoard_ID(id))
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },
    GET_UserBoard_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.userassignboard.GET_UserBoard_ID(id))
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },
    GET_ASSIGN_USER_BY_BOARD_ID: (id,search,falsePagination,page) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(id, search,falsePagination,page))
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    }
};
